<template>
  <div id="Footer">
    <div class="container">
      <a id="FooterImg" href="/">
        <img src="../../assets/images/logo.png" alt="Autism Diagnosis and Support" />
      </a>
      <div id="FooterLinks">
        <h3>Links</h3>
        <router-link
          v-for="(link, index) in links"
          :key="index"
          :to="link.url"
          >{{ link.text }}</router-link
        >
      </div>
      <p>
        This website was built by Jake Rivett - email: jake_rivett@hotmail.com
      </p>
      <p>Business Address: 17 McBain Place, Kinross KY13 8QZ</p>
      <p>
        Icons made by
        <a
          href="https://www.flaticon.com/authors/pixel-perfect"
          title="Pixel perfect"
          >Pixel perfect</a
        >
        from
        <a href="https://www.flaticon.com/" title="Flaticon"
          >www.flaticon.com</a
        >
        is licensed by
        <a
          href="http://creativecommons.org/licenses/by/3.0/"
          title="Creative Commons BY 3.0"
          target="_blank"
          >CC 3.0 BY</a
        >
        and <a href="http://www.freepik.com" title="Freepik">Freepik</a> from
        <a href="https://www.flaticon.com/" title="Flaticon"
          >www.flaticon.com</a
        >
        is licensed by
        <a
          href="http://creativecommons.org/licenses/by/3.0/"
          title="Creative Commons BY 3.0"
          target="_blank"
          >CC 3.0 BY</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import shared from "../shared";

export default {
  props: {
    links: Array,
  },
  methods: {
    onLinkClick(link) {
      shared.onLinkClick(link);
    },
  },
};
</script>

<style lang="scss">
@import "./../../variables.scss";

#FooterImg > img {
  display: block;
  margin-bottom: $space-4;
  height: 64px;
  width: auto;
  opacity: 0.4;
}

#FooterLinks {
  margin-bottom: $space-6;
  > h3 {
    margin: 0 0 $space-2;
    font-size: $medium;
    color: $third;
    opacity: 0.8;
  }
  > * {
    color: white;
    opacity: 0.6;
    display: block;
    padding: $space-1 0;
    font-size: $small;
    text-decoration: none;
    transition: opacity 0.15s ease;
    &:hover {
      opacity: 1;
      cursor: pointer;
    }
  }
}

#Footer {
  background-color: #1a1a1a;
  border-top: 1px solid #232323;
  padding: $space-8 0;
  > .container > p {
    font-size: $verySmall;
    line-height: 1.5;
    color: white;
    opacity: 0.6;
    margin: 0 0 $space-2;
    > a {
      color: inherit;
    }
  }
}
</style>
